import type { ChatRefDoc } from '@/app/services/chat';
import type { BatchDocDetail } from '@/app/services/session';

export function mergeReferencePreviewDocDetail(
  current: ChatRefDoc,
  docDetail: BatchDocDetail | null,
  docId: string | null,
) {
  if (!docDetail) return { ...current, doc_id: current.doc_id ?? docId };
  if (docDetail.doc_id && docDetail.doc_id !== docId) {
    return { ...current, doc_id: current.doc_id ?? docId };
  }

  return {
    ...current,
    ...docDetail,
    doc_id: docDetail.doc_id ?? current.doc_id ?? docId,
    abstract: docDetail.abstract ?? current.abstract,
    publication: docDetail.publication ?? current.publication,
    publisher:
      docDetail.publication ?? docDetail.publisher ?? current.publisher,
    publisher_abbr:
      docDetail.publication_abbr ??
      docDetail.publisher_abbr ??
      current.publisher_abbr,
    pub_day:
      docDetail.pub_day == null ? current.pub_day : String(docDetail.pub_day),
    pub_language: docDetail.pub_language ?? current.pub_language,
    translation: docDetail.translation ?? current.translation,
  };
}
